/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tourhelp_ResumeInputs */

const en_tourhelp_resume = /** @type {(inputs: Tourhelp_ResumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resume`)
};

/** @type {(inputs: Tourhelp_ResumeInputs) => LocalizedString} */
const ar_tourhelp_resume = en_tourhelp_resume;

/** @type {(inputs: Tourhelp_ResumeInputs) => LocalizedString} */
const he_tourhelp_resume = en_tourhelp_resume;

/** @type {(inputs: Tourhelp_ResumeInputs) => LocalizedString} */
const ur_tourhelp_resume = en_tourhelp_resume;

/** @type {(inputs: Tourhelp_ResumeInputs) => LocalizedString} */
const es_tourhelp_resume = en_tourhelp_resume;

/** @type {(inputs: Tourhelp_ResumeInputs) => LocalizedString} */
const fr_tourhelp_resume = en_tourhelp_resume;

/** @type {(inputs: Tourhelp_ResumeInputs) => LocalizedString} */
const de_tourhelp_resume = en_tourhelp_resume;

/** @type {(inputs: Tourhelp_ResumeInputs) => LocalizedString} */
const pt_tourhelp_resume = en_tourhelp_resume;

/** @type {(inputs: Tourhelp_ResumeInputs) => LocalizedString} */
const hi_tourhelp_resume = en_tourhelp_resume;

/** @type {(inputs: Tourhelp_ResumeInputs) => LocalizedString} */
const bn_tourhelp_resume = en_tourhelp_resume;

/**
* | output |
* | --- |
* | "Resume" |
*
* @param {Tourhelp_ResumeInputs} inputs
* @param {{ locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }} options
* @returns {LocalizedString}
*/
export const tourhelp_resume = /** @type {((inputs?: Tourhelp_ResumeInputs, options?: { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tourhelp_ResumeInputs, { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_tourhelp_resume(inputs)
	if (locale === "he") return he_tourhelp_resume(inputs)
	if (locale === "ur") return ur_tourhelp_resume(inputs)
	if (locale === "es") return es_tourhelp_resume(inputs)
	if (locale === "fr") return fr_tourhelp_resume(inputs)
	if (locale === "de") return de_tourhelp_resume(inputs)
	if (locale === "pt") return pt_tourhelp_resume(inputs)
	if (locale === "hi") return hi_tourhelp_resume(inputs)
	if (locale === "bn") return bn_tourhelp_resume(inputs)
	return /** @type {LocalizedString} */ ("Resume")
});